module.exports = __webpack_public_path__ + "img/btn-bg.eb607113.png";